import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DialogBase } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-location-access',
  templateUrl: './location-access.html',
  styleUrls: ['./location-access.css'],
  standalone: false
})
export class LocationAccessDialog extends DialogBase implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LocationAccessDialog>,
    @Inject(MAT_DIALOG_DATA) public data) {
    super("LocationAccessDialog");

  }
  async ngOnInit() {
  }
  public openSettings() {
    this.dialogRef.close('openSettings');
  }
  public startRentAnyway() {
    this.dialogRef.close('start');
  }
}
